import React, { Suspense } from 'react';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';
import { strings } from '@constants/strings';
import { Label, MapContainer, Skeleton } from '@common-web';

const SelectPinLocation = (props) => {
  const { t } = useTranslation();
  const defaultHeight = 228;
  const height = props?.mapHeight ?? defaultHeight;
  const handleMapsClick = (latLng) => {
    const lat = latLng.lat;
    const lng = latLng.lng;
    props.onSetMarker({ lat, lng });
  };

  const renderMaps = () => {
    return (
      <>
        {props.loading ? (
          <Skeleton height={height} width={'100%'} />
        ) : (
          <Suspense fallback={<Skeleton height={height} width={'100%'} />}>
            <MapContainer
              mapHeight={height}
              latLng={props.latLng}
              handleMapsClick={handleMapsClick}
              locationInput={props.locationInput}
            />
          </Suspense>
        )}
      </>
    );
  };

  const renderLabel = () => {
    return (
      <Label>
        {props.loading ? <Skeleton height={24} width={210} /> : props?.label ? props?.label : t(strings.pin_location)}
      </Label>
    );
  };

  return (
    <div className={cx(props.className)}>
      {renderLabel()}
      {renderMaps()}
    </div>
  );
};

export default SelectPinLocation;
